import type { Element as XmlEl } from "@xmpp/xml"

import { toJid, type Jid } from "../../jid"
import { attr } from "../../xmlUtils"
import { carbonPayload } from "./payload"

/**
 * Whether this carbon really came from us.
 *
 * MUST be checked before trusting one. The endpoint takes raw XMPP from
 * anything holding a session token, so without this any peer can send a
 * `<sent>` carbon and have it render as a message you wrote, in a conversation
 * they choose. The envelope's `from` is the only thing they cannot forge.
 */
export const isCarbonBy = (xml: XmlEl, jid: Jid): boolean => {
  const from = attr(xml, "from")
  return !!from && toJid(from) === jid
}

/** Whether this stanza is a carbon at all — checked before trusting one. */
export const isCarbon = (xml: XmlEl): boolean => !!carbonPayload(xml)

export * from "./unwrap"
